import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../core/service'

export const getTopHighestPortfolio = createAsyncThunk(
  'portfolio/summary/getTopHighestPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getTopHighestPortfolio(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getTopHighestIndustry = createAsyncThunk(
  'portfolio/summary/getTopHighestIndustry',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getTopHighestIndustry(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportTopHighestScore = createAsyncThunk(
  'portfolio/summary/exportTopHighestScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.exportTopHighestScore(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
